import { UpdaterVersionItemArray } from './../../../../models/domain/updater.version.item';
import { UserRolesService } from '../../../../services/user.roles.service';
import { LicenseManager } from '../../../../managers/License.manager';
import { LiveHubService } from './../../../../services/livehub.service';
import { Component, OnInit, Input } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { clientFilesFilter } from '../../../../pipes/filter.pipe';
import { ssApiService } from '../../../../services/ss-api.service';
import { WMIItemArray } from '../../../../models/livehub/wmi';
import { UpdateVersionForceGroupItemArray } from '../../../../models/domain/update.version.force.group.item';
import { AdminReinstallLiveHubRequest } from '@models/ss-api/requests/admin.reinstall.live.hub.request';
import { UpdaterVersionForceGroupItemArray } from '@models/domain/updater.version.force.group.item';
import { UploadDatabaseLogsRequest } from '@models/ss-api/requests/upload.database.logs.request';

@Component({
    selector: 'livehub-manager',
    templateUrl: './livehub.component.html',
    styleUrls: ['./livehub.component.scss']
})

export class LiveHubManagerComponent implements OnInit {
    IsBusy: boolean = false;

    @Input('licenseManager') licenseManager: LicenseManager;
    @Input('Subscriptions') Subscriptions;

    // WMI Data
    WMIData: WMIItemArray = new WMIItemArray();
    CustomWMIQuery: string;

    KillLicenseLabel: string = 'Stop SE3D_Core.exe';

    UpdaterVersions: UpdaterVersionItemArray = new UpdaterVersionItemArray();
    SelectedReinstallVersion: string;
    Groups: UpdateVersionForceGroupItemArray;
    GroupsV3: UpdateVersionForceGroupItemArray;
    SelectedGroup;
    DefaultGroupName: string;
    DefaultGroupNameV3: string;
    DefaultUpdaterGroupName: string;

    constructor(private liveHub: LiveHubService, private sweetAlert: SweetAlertService, private clientFilesFilter: clientFilesFilter, private api: ssApiService, public roles: UserRolesService) { }

    ngOnInit() {
        // this.IsBusy = true;
        this.liveHub.ResetLiveHubResponse.subscribe(response => {
            // console.log("Reset LiveHub Response: ", response);
        });

        this.liveHub.KillLicensePoolStudioResponse.subscribe(response => {
            // console.log(response)
        });

        this.liveHub.ReinstallLiveHubResponse.subscribe(response => {
            if (response) {
                this.sweetAlert.swal({
                    type: 'Reinstall Initiated Successfully',
                    text: 'The request has been received by the client. This does not mean that the reinstall was successful',
                    timer: 1500
                }).then( () => {}, () => {} );
            }
        });

        this.liveHub.IgnoreHardwareCheckChangedResponse.subscribe(response => {
            console.log("IHC", response);
            if (response) {

                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Member Setting Updated',
                    text: "The member's system acknowledged your change",
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false,
                    }).then( () => {}, () => {} );
            }
            else{
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Failed to Update Setting',
                    text: response.Message,
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false,
                    }).then( () => {}, () => {} );

            }
        });

        this.LoadUpdaterVersions();
        this.LoadGroups();
        this.LoadGroupsV3();
    }

    LoadUpdaterVersions() {
        let disposable = this.api.GetUpdaterVersions().subscribe(response => {
            if (response.Result) {
                this.UpdaterVersions = response.Data;
            }
            disposable.unsubscribe();
        });
    }

    LoadGroups() {
        let disposable = this.api.GetUpdateVersionForceGroups().subscribe(response => {
            this.Groups = response.Data;
            this.Groups.forEach((group) => {
                if (group.IsDefault) {
                    this.DefaultGroupName = group.Name;
                }
            });

            if (!this.licenseManager.License().UpdateVersionForceGroupID) {
                this.licenseManager.License().UpdateVersionForceGroupID = -1;
            }
            disposable.unsubscribe();
        });
    }

    LoadGroupsV3() {
        let disposable = this.api.GetUpdateVersionForceGroupsV3().subscribe(response => {
            this.GroupsV3 = response.Data;
            console.log("gv3", response.Data);
            this.GroupsV3.forEach((group) => {
                if (group.IsDefault) {
                    this.DefaultGroupNameV3 = group.Name;
                }
            });

            if (!this.licenseManager.License().UpdaterV3VersionForceGroupID) {
                this.licenseManager.License().UpdaterV3VersionForceGroupID = -1;
            }
            disposable.unsubscribe();
        });
    }


    IsVersionLiveHubCompatible(SoftwareVersion: string){
        //Check for an empty value - that will never be compatible with LiveHub
        if (SoftwareVersion.length === 0 || !SoftwareVersion.trim()){
            return false;
        }

        var cleanSoftwareVersion = SoftwareVersion.replace(/\D/g,'');

        if (cleanSoftwareVersion.length < 4){
            while (cleanSoftwareVersion.length < 4){
                cleanSoftwareVersion = cleanSoftwareVersion + "0";
            }
        }

        var nmcleanSoftwareVersion = Number(cleanSoftwareVersion);

        if (isNaN(nmcleanSoftwareVersion)){
            return false;
        }

        if (nmcleanSoftwareVersion < 2620){
            return false;
        }

        return true;

    }

    UpdateGroup() {
        // this.licenseManager.SaveChanges(true, true);
    }

    UpdaterGroup() {
        // this.licenseManager.SaveChanges(true, true);
    }

    SendUpdate(){
        this.sweetAlert.swal({
            type: 'warning',
            text: 'Are you sure you want to send the update to this license??',
            showCancelButton: true
        }).then( () => {
            this.liveHub.InvokeConnection('NotifySpecificMemberOfNewVersion', this.licenseManager.License().Key);
        }, () => { });
    }

    ResetLiveHub() {
        this.sweetAlert.swal({
            type: 'warning',
            text: 'Are you sure?',
            showCancelButton: true
        }).then( () => {
            this.liveHub.InvokeConnection('ResetLicenseLiveHub', this.licenseManager.License().Key);
        }, () => { });
    }

    UploadDatabaseLogs() {
        this.sweetAlert.swal({
            type: 'warning',
            text: 'Are you sure you want to upload database logs for the past week?',
            showCancelButton: true
        }).then( () => {
            var uploadRequest = new UploadDatabaseLogsRequest();
            uploadRequest.LicenseKey = this.licenseManager.License().Key;
            uploadRequest.NumberOfDays = 7;
            this.liveHub.InvokeConnection('UploadDatabaseLogs', uploadRequest);
        }, () => { });
    }

    KillLicense() {
        this.liveHub.InvokeConnection('StopPoolStudio', this.licenseManager.License().Key);
    }

    ReinstallLiveHub() {
        this.sweetAlert.swal({
            type: 'warning',
            text: 'Are you sure?',
            showCancelButton: true
        }).then( () => {
            var reinstallLiveHubRequest = new AdminReinstallLiveHubRequest();
            reinstallLiveHubRequest.LicenseKey = this.licenseManager.License().Key;
            this.liveHub.InvokeConnection('ReinstallLiveHub', reinstallLiveHubRequest);
        });
    }

}
